import { createAsyncThunk } from "@reduxjs/toolkit";
import { getClientLicenseListAPI } from "../../apiConfig/apiCall";

export const getClientLicenseList = createAsyncThunk('getClientLicenseList', async (CLIENT_ID) => {
    const response = await getClientLicenseListAPI(CLIENT_ID);
    return response.data;
});